import api, { API_BASE_URL } from './api';

/** Paths relative to /api/ when base URL is origin-only (local dev). */
function apiPath(suffix) {
  const p = suffix.startsWith('/') ? suffix : `/${suffix}`;
  const base = (API_BASE_URL || '').replace(/\/$/, '');
  if (base.endsWith('/api')) {
    return p;
  }
  return `/api${p}`;
}

/** Teacher info */
export function getTeacherMe() {
  return api.get(apiPath('/teacher/me/'));
}

export function getTeacherRoster() {
  return api.get(apiPath('/teacher/roster/'));
}

export function getEmergencyInfo() {
  return api.get(apiPath('/teacher/emergency-info/'));
}

/** Attendance */
export function getAttendance(date) {
  return api.get(apiPath('/teacher/attendance/'), { params: { date } });
}

export function saveAttendance(data) {
  return api.post(apiPath('/teacher/attendance/'), data);
}

export function getAbsenceReasons() {
  return api.get(apiPath('/teacher/absence-reasons/'));
}

/** Newsletters */
export function getNewsletters() {
  return api.get(apiPath('/teacher/newsletters/'));
}

export function createNewsletter(data) {
  return api.post(apiPath('/teacher/newsletters/'), data);
}

/** Threads */
export function getThreads() {
  return api.get(apiPath('/teacher/threads/'));
}

export function startThread(data) {
  return api.post(apiPath('/teacher/threads/start/'), data);
}

export function getThread(id) {
  return api.get(apiPath(`/teacher/threads/${id}/`));
}

export function sendMessage(threadId, data) {
  return api.post(apiPath(`/teacher/threads/${threadId}/messages/`), data);
}

export function blastClass(data) {
  return api.post(apiPath('/teacher/threads/blast/'), data);
}
